import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {Subject} from 'rxjs';
import {HttpService} from '../apiServices/http-service.service';
import {ApiConst} from '../apiServices/api-const';
import {User} from '../../model/user';

/**
 * Handle the save of fold Datatables user param (order and width)
 */
@Injectable()
export class CustomTableSaverService {


  /**
   * the list of columns as subject
   */
  public customFoldTableSubject: Subject<any>;

  /**
   * the list of column
   */
  private listOfColumnsInStorage;

  /**
   * will be removed when back-office save will be done
   */
  private _userLogged: User;

  /**
   * if the user update displayParams it'll be changed to true
   */
  public userUpdatedFoldParams: boolean;

  /**
   * Default constructor, instantiate variables and launch init function
   * @param {StorageService} storageService - handle param save for session
   * @param {HttpService} httpService - handle param save on server
   */
  constructor(private storageService: StorageService, private httpService: HttpService) {
    this.userUpdatedFoldParams = false;
    this.customFoldTableSubject = new Subject();
    this.init();
  }

  /**
   * get datas from storage and handle subscription (to update storage and values)
   */
  private init(): void {

    this.customFoldTableSubject.subscribe(change => {
      this.listOfColumnsInStorage = change;
      this.storageService.addTempoFoldParamIntoStorage(this._userLogged, change);
    });

    // Usefull when back-office request will be done, else not

    // const fromStorage = this.storageService.getFoldDatatablesParamsFromStorage();
    // if (fromStorage) {
    //   this.listOfColumnsInStorage = fromStorage;
    //   this.customFoldTableSubject.next(fromStorage);
    // }
  }

  /**
   *
   * handle the change of tableOrder
   *
   * @param {any} newColumnsOrder - the new columns sorted by the component
   * @param {number} defaultWidth - here to set default width (if not already done)
   */
  public updateFoldTableOrder(newColumnsOrder: any, defaultWidth: number): void {
    const newColumns = [];
    let index = 0;
    for (const column of newColumnsOrder) {

      if (column.style && column.style.width) {
        // Dirty style parse
        const width = column.style.width.substring(0, column.style.width.length - 2);
        newColumns.push({field: column.field, header: column.header, width: width, index: index});
      }
      else {
        newColumns.push({field: column.field, header: column.header, width: defaultWidth, index: index});
      }
      index++;
    }
    this.customFoldTableSubject.next(newColumns);
    this.userUpdatedFoldParams = true;
  }

  /**
   *
   * handle the change of column's width
   *
   * @param {any} newParams - the column itself and other usefull information (default with, new one...)
   */
  public updateFoldTableWidth(newParams: any): void {
    const newColumns = [];
    let index = 0;
    for (const column of newParams.columns) {
      // column to update
      if (column.header === newParams.cellHeader) {
        newColumns.push({field: column.field, header: column.header, width: newParams.cellWidth, index: index});
      }
      // column creation (for width)
      else if (!column.width) {
        newColumns.push({field: column.field, header: column.header, width: newParams.defaultWidth, index: index});
      }
      // column recopy
      else {
        newColumns.push(column);
      }
      index++;
    }
    this.customFoldTableSubject.next(newColumns);
    this.userUpdatedFoldParams = true;
  }

  /**
   * Determine if a column is present in storage and if it matches the desired criteria
   * @param {string} fieldID - the column ID
   * @return {boolean} - true if exist
   */
  public criteriaIsPresentAsColumn(fieldID: string): boolean {
    if (this.listOfColumnsInStorage) {
      for (const column of this.listOfColumnsInStorage) {
        if (fieldID === column.field) {
          return true;
        }
      }
      return false;
    }
    else {
      return false;
    }
  }

  /**
   * get column from storage using ID
   * @param {string} fieldID - the column ID
   * @return {any} - the column if it exists, else null
   */
  public getColumnwithId(fieldID: string) {
    for (const column of this.listOfColumnsInStorage) {
      if (fieldID === column.field) {
        return column;
      }
    }
    return null;
  }

  /**
   * get the list of Params from server and build them
   *
   * @param {any} toBuild - list of custom params gave by back-office
   * @param {User} user - user connected
   */
  public buildUserParams(toBuild: any, user: User) {
    this.storageService.removeFoldDatatablesParamsFromStorage(user);
    this.customFoldTableSubject.next(toBuild);
  }

  /**
   * peform the needed http to send custom params to back-office if any changed has been made by user
   */
  public updateUserParamsToServer() {
    if (this.userUpdatedFoldParams) {
      const datasToSend = JSON.stringify({
        datas: this.listOfColumnsInStorage
      });
      this.httpService.$post(ApiConst.sendCustomFoldListParam, datasToSend);
    }
  }

  /**
   *  /_!_\ Temporary, should be removed when back-office param gestion will be effective
   * @param {User} user - the user to log
   */
  set userLogged(user: User) {
    this._userLogged = user;
    const fromStorage = this.storageService.getTempoFoldParamFromStorage(user);

    if (fromStorage) {
      this.listOfColumnsInStorage = fromStorage;
      this.customFoldTableSubject.next(fromStorage);
    }
  }
}
